import { authApi } from "@/api/auth";
import { organizationApi } from "./organizations";
import { projectConfigApi } from "./projectConfigs";
import { projectApi } from "./projects";
import { teamApi } from "./teams";
import { ticketApi } from "./tickets";
import { userApi } from "./users";
import { followUpApi } from "./followups";
import { subscriptionApi } from "./subscriptions";
import { notificationConfigurationApi } from "./notificationConfigurations";
import { iconApi } from "./icons";
import { customDataApi } from "./customData";
import { jiraSyncApi } from "./jiraSync";
import { maintenanceApi } from "./maintenance";
import { adminDashboardApi } from "./adminDashboard";
import { workQueueApi } from "./workQueue";
import { tokenApi } from "./tokens";
import { companyApi } from "./companies";
import { systemSettingsApi } from "./systemSettings";
import { supportCalendarsApi } from "./supportCalendars";
import { supportApi } from "./support";
import { pagerDutyApi } from "./pagerduty";
import { workLogApi } from "./workLogs";
import { agentSessionApi } from "./agentSessions";

const api = {
    auth: authApi,
    organizations: organizationApi,
    projects: projectApi,
    projectConfigs: projectConfigApi,
    teams: teamApi,
    tickets: ticketApi,
    users: userApi,
    followUps: followUpApi,
    subscriptions: subscriptionApi,
    notificationConfigurations: notificationConfigurationApi,
    icons: iconApi,
    customData: customDataApi,
    jiraSync: jiraSyncApi,
    maintenance: maintenanceApi,
    adminDashboard: adminDashboardApi,
    workQueue: workQueueApi,
    tokens: tokenApi,
    companies: companyApi,
    systemSettings: systemSettingsApi,
    supportCalendars: supportCalendarsApi,
    support: supportApi,
    pagerDuty: pagerDutyApi,
    workLogs: workLogApi,
    agentSessions: agentSessionApi,
};

export type Api = typeof api;

export function useApi(): Api {
    return api;
}
